import type { RootState } from "@/app/store";
import { AnaliseLaboratorial } from "@/contexts/laboratorio/analiseLaboratorial/model/AnaliseLaboratorial";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface RequisicaoAnaliseLaboratorialState {
  items: AnaliseLaboratorial[];
}

const initialState: RequisicaoAnaliseLaboratorialState = {
  items: [],
};

const requisicaoAnaliseLaboratorialSlice = createSlice({
  name: "REQUISICAO_ANALISE_LABORATORIAL",
  initialState,
  reducers: {
    add: {
      reducer: (
        state,
        action: PayloadAction<{ item: AnaliseLaboratorial }>
      ) => {
        const { item } = action.payload;
        state.items.push({ ...item, offlineId: Date.now() });
      },
      prepare: (item: AnaliseLaboratorial) => ({
        payload: { item },
      }),
    },
    remove: {
      reducer: (state, action: PayloadAction<{ offlineId: number }>) => {
        state.items = state.items.filter(
          (item) => item.offlineId !== action.payload.offlineId
        );
      },
      prepare: (offlineId: number) => ({
        payload: { offlineId },
      }),
    },
    update: {
      reducer: (
        state,
        action: PayloadAction<{ item: AnaliseLaboratorial }>
      ) => {
        const index = state.items.findIndex(
          (item) => item.offlineId === action.payload.item.offlineId
        );
        state.items[index] = action.payload.item;
      },
      prepare: (item: AnaliseLaboratorial) => ({
        payload: { item },
      }),
    },
  },
});

export const requisicaoAnaliseLaboratorialAction =
  requisicaoAnaliseLaboratorialSlice.actions;

export default requisicaoAnaliseLaboratorialSlice.reducer;

export const getRequisicoesAnaliseLaboratorial = (state: RootState) => {
  const listaInvertida = state.requisicaoAnaliseLaboratorial.items.map(
    (_, ind, lista) => {
      return lista[lista.length - ind - 1];
    }
  );

  return listaInvertida;
};
